import { Canvas, FabricImage } from 'fabric'; // browser

if (document.getElementById('configurator-canvas')) {

    let canvas = new Canvas('configurator-canvas');

    document.getElementById('upload-to-canvas').addEventListener("change", function(e){
        var reader = new FileReader();

        reader.onload = function (event){
            var imgObj = new Image();
            imgObj.src = event.target.result;

            // When the picture loads, create the image in Fabric.js
            imgObj.onload = function () {
                var img = new FabricImage(imgObj);

                img.scaleToHeight(300);
                img.scaleToWidth(300);
                canvas.centerObject(img);
                canvas.add(img);
                canvas.renderAll();
            };
        };

        // If the user selected a picture, load it
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }
    }, false);

    // When the user selects a picture that has been added and press the DEL key
    // The object will be removed !
    document.addEventListener("keydown", function(e) {
        var keyCode = e.keyCode;

        if(keyCode == 46){
            console.log("Removing selected element on Fabric.js on DELETE key !");
            canvas.remove(canvas.getActiveObject());
        }
    }, false);
}

function updateTshirtImage(imageURL){
    fabric.Image.fromURL(imageURL, (img) => {
        img.scaleToHeight(300);
        img.scaleToWidth(300);
        canvas.centerObject(img);
        canvas.add(img);
        canvas.renderAll();
    });
}

